import { createSlice } from "@reduxjs/toolkit";
import {
  addCity,
  deleteCity,
  getAllCities,
  getAllCountries,
  getCityDetails,
  getCityList,
  updateCity,
  updateCityStatus,
} from "store/actions/citySlice";

const initialState = {
  isLoading: false,
  loading: true,
  perPage: 10,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  cities: [],
  countries: [],
  citiesList: [],
  cityDetails: {},
  gettingDetails: false,
};

const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    // You can define additional synchronous actions here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCities.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};

          state.cities = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllCities.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getCityList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCityList.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.citiesList = data;
        }
      })
      .addCase(getCityList.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateCityStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCityStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.cities = state?.cities?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateCityStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(addCity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.cities.push(data);
        }
      })
      .addCase(addCity.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateCity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.cities = state?.cities?.map((item) =>
            item._id === data._id ? data : item
          );
        }
      })
      .addCase(updateCity.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getCityDetails.pending, (state) => {
        state.gettingDetails = true;
      })
      .addCase(getCityDetails.fulfilled, (state, action) => {
        state.gettingDetails = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.cityDetails = data;
        }
      })
      .addCase(getCityDetails.rejected, (state, action) => {
        state.gettingDetails = false;
      });

    builder.addCase(deleteCity.pending, (state) => {
      state.isLoading = true;
    }).addCase(deleteCity.fulfilled, (state, action) => {
      state.isLoading = false;
      const { success } = action.payload || {};
      if (success) {
        const { id } = action.meta.arg;
        state.cities = state.cities.filter((item) => item._id !== id);
        if (state.totalCount !== null) {
          state.totalCount -= 1;
        }
      }
    }).addCase(deleteCity.rejected, (state, action) => {
      state.isLoading = false;
    });
    // Extra case for Tod_Workspace (For getting countries)
    builder.addCase(getAllCountries.pending, (state) => {
      state.isLoading = true;
    }).addCase(getAllCountries.fulfilled, (state, action) => {
      state.isLoading = false;
      const { success, data } = action.payload || {};
      if (success) {
        state.countries = data; 
      }

    }).addCase(getAllCountries.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export default citySlice.reducer;
